import { NutritionDto } from '.';

export class ProductDto {
  public receiptText: string;
  public buttonText: string;
  public minorGroupID: number;
  public taxRate: number;
  public modifiers: number[];
  public allergens: number[];
  public nutrition: NutritionDto;
  public id: number;
  public name: string;
}
